<div *ngIf="dailyPrices.length > 0" class="daily-prices-carousel-container">
  <button
    class="carousel-btn carousel-btn-left"
    (click)="scrollLeft()"
    [disabled]="currentIndex === 0">
    ‹
  </button>

  <div class="daily-prices-carousel" #scrollContainer>
    <div *ngFor="let dailyPrice of dailyPrices; let i = index" class="price-card-wrapper">
      <div class="price-card">
        <div class="d-flex justify-content-center align-items-center">
          <p class="week-days mb-0">{{dailyPrice.dayWeek}}</p>
        </div>
        <p class="number-day mt-2 mb-0">{{dailyPrice.date | date: 'dd-MM-yyyy'}}</p>
        <p class="price mb-0 mt-2">
          {{currencyAgency.code}}
          {{ dailyPrice.price
            | currencyConverterPure:
              dailyPrice.currency:
              currencyAgency.code:
              currencies
            | number: '1.2-2'}}
        </p>
      </div>
    </div>
  </div>

  <button
    class="carousel-btn carousel-btn-right"
    (click)="scrollRight()"
    [disabled]="currentIndex >= maxIndex">
    ›
  </button>
</div>
